import _ from 'lodash';

import config from 'config';

const appendGoogleAddressTag = () => {
  if (!$('#google_address_tag').length) {
    let tag = angular.element(`<script id="google_address_tag" src="https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_PLACES_API_KEY}&libraries=places&callback=initAutocomplete" async defer></script>`);
    angular.element(document.querySelector('head')).append(tag);
  }
};

const findComponentType = (components, componentType, nameType) => {
  let retVal = _.find(components, component => _.find(component.types, type => type === componentType));

  return retVal ? retVal[`${nameType}_name`] : '';
};

export default [
  '$window',
  function googleAddressAutocomplete($window) {
    return {
      restrict: 'A',
      link: (scope, el) => {
        let placeSearch,
          autocomplete;

        $window.initAutocomplete = () => {
          autocomplete = new google.maps.places.Autocomplete(el[0], { types: ['geocode'] });
          autocomplete.addListener('place_changed', fillInAddress);
        };

        $window.fillInAddress = () => {
          let place = autocomplete.getPlace(),
            components = place.address_components,
            country = document.getElementsByName('country')[0];


          country.value = `string:${findComponentType(components, 'country', 'short')}`;
          $(country).change();

          // defer so the address form can update after the country is changed
          _.delay(() => {
            let address = document.getElementsByName('address')[0],
              city = document.getElementsByName('city')[0],
              state = document.getElementsByName('state')[0],
              zip = document.getElementsByName('zip')[0],
              address2 = document.getElementsByName('apt')[0],
              streetNumber = findComponentType(components, 'street_number', 'long'),
              streetName = findComponentType(components, 'route', 'short');

            city.value = findComponentType(components, 'locality', 'short') || findComponentType(components, 'postal_town', 'short');
            zip.value = findComponentType(components, 'postal_code', 'short');

            if (streetNumber) {
              address.value = `${streetNumber} ${streetName}`;
            } else {
              let matches = el[0].value.match(/(^[0-9\/-]+\s*(?:[a-zA-Z](?![a-zA-Z]))?)/),
                routeMatches = streetName.match(/(^[0-9\/-]+\s*(?:[a-zA-Z](?![a-zA-Z]))?)/);

              if (matches.length && !routeMatches) {
                address.value = `${matches[0].trim()} ${streetName}`;
              } else {
                address.value = `${streetName}`;
              }
            }

            if (country.value === 'string:US' || country.value === 'string:CA') {
              state.value = `string:${findComponentType(components, 'administrative_area_level_1', 'short')}`;
            } else {
              state.value = findComponentType(components, 'administrative_area_level_1', 'long');
            }

            if (country.value !== "string:US") {
              address2.value = findComponentType(components, 'neighborhood', 'long');
              $(address2).change();
            }

            $(address).change();
            $(city).change();
            $(zip).change();
            $(state).change();
          }, 100);
        };

        appendGoogleAddressTag();
      }
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/google-address-autocomplete/google-address-autocomplete.dir.js